<template>
  <div class="mep content">
    <h1>You are a Member of the European Parliament and want to join the pledge?</h1>
    <p>Contact us at <a href="mailto:mep@pledge2019.eu">mep@pledge2019.eu</a> and we will guide you through the next steps. Here is the text:</p>
    <div class="pledge-text">
      <p>I pledge to vote against the Trilogue agreement on the Directive on Copyright in the Digital Single Market unless Article 13 (final article numbering may change) on upload filters is removed and that I will be present at the plenary vote.</p>
    </div>
    <p>If you fear attacks from the copyright industry, you can sign this pledge anonymously. In this case we will only release your name a couple of days ahead of the final plenary vote on the copyright directive. All pledges will be checked with the final voting behavior.</p>
  </div>
</template>

<script>
import SectionExplainer from '@/components/SectionExplainer'

export default {
  name: 'Mep',
  components: {
    SectionExplainer,
  },
}
</script>

<style lang=scss scoped>
.mep {
  .pledge-text {
    background-color: white;
    padding: 1em 2em;
    max-width: 768px;
    margin: 1em auto;
  }
}
</style>
